<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-07 16:59:48
 * @LastEditors: xzx
 * @LastEditTime: 2021-01-11 10:49:07
-->
<template>
    <div style="width: 100%; height: 300px;display: inline-block;">
        <div :ref="setRef" style="width:100%; height:100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { computed, onMounted, onUnmounted, reactive, watchEffect } from "vue";
import { useStore } from 'vuex'

export default {
    name: "tw-pie",
    
    setup(props) {
        let myRef;
        let myChart;

        // 主题
        const store = useStore()
        const isDark = computed(() => {
            return store.state.isDark
        })

        const setRef = el => {
            myRef = el;
        }

        let mockJson = reactive({"data":{"series":[{"name":"访问来源","data":[
            {value:235, name:'视频广告'},
            {value:274, name:'联盟广告'},
            {value:310, name:'邮件营销'},
            {value:335, name:'直接访问'},
            {value:400, name:'搜索引擎'}
            ]}]}});

        const dataInit = function() {
            if(mockJson && mockJson.data && mockJson.data.series){
                mockJson.data.series.forEach(function(val){
                    val.type = 'pie';
                    val.radius = `${props.radius}%`;
                    val.roseType = props.roseType;
                })
            }
        }

        const echartInit = () =>{
            // echarts.registerTheme('tw_dark', twDark)
            myChart = echarts.init(myRef);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title
                },
                legend: {
                    show: props.legendShow,
                    textStyle: {
                        color: isDark.value ? '#ebedef' : '#495057'
                    }
                },
                tooltip: {
                    show: true
                },
                series: mockJson.data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        // 窗口改变大小时需要刷新饼图
        const onResize = function() {
            setTimeout(() => {
                myChart.resize()
            }, 100);
        }

        onMounted(()=>{
            window.addEventListener("resize", onResize)

            watchEffect(() => {
                const data = props.data_source && props.data_source.datas

                if (data) {
                    if (data.data && data.data.series) {
                        // 数据源本身为 echarts 数据格式时
                        mockJson = reactive(props.data_source.datas)
                    } else {
                        // 数据源为数据库表结构时
                        if (Array.isArray(data) && props.caption_name && props.value_name) {
                            const chartData = { data: { series:[{ name: props.series_name, data: [] }]}}
                            data.forEach(el => {
                                chartData.data.series[0].data.push({
                                    name: el[props.caption_name],
                                    value: el[props.value_name] 
                                })
                            })
                            mockJson = reactive(chartData)
                        } else {
                            // 属性未选完，不用提示错误
                            // ElMessage.error('饼图：请检查【数据源】数据格式');
                            mockJson = reactive({
                                data: {
                                    categories: [],
                                    series: []
                                }
                            })
                        }
                    }
                }
                dataInit()
                echartInit()
            })
        })

        onUnmounted(() => {
            document.removeEventListener('resize', onResize, true)
        })

        return {
            setRef,
            echartInit
        };

    },
    props: {
        title: String,
        roseType: {
            type: Boolean,
            default: false
        },
        legendShow: {
            type: Boolean,
            default: true
        },
        radius: {
            type: Number,
            default: 45
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        series_name: {
            type: String,
            default: '',
        },
        caption_name: {
            type: String,
            default: ''
        },
        value_name: {
            type: String,
            default: ''
        }
    }
  }
</script>

<style>

</style>